import { palette } from "../../Theme/palette";
export const MuiLinearProgress = {
    variants: [
        {
            props: { color: "gradient" },
            style: {
                /**
                 * A short explanation about the classes we override for "gradient":
                 * MuiLinearProgress-bar1Determinate - the "value" bar in variant=determinate
                 * MuiLinearProgress-bar1Buffer - the "value" bar in variant=buffer (we don't override the "buffer" bar, only the value bar)
                 * MuiLinearProgress-bar1Indeterminate, MuiLinearProgress-bar2Indeterminate - the moving bars (there are two) in variant=indeterminate
                 */
                "& .MuiLinearProgress-bar1Determinate, & .MuiLinearProgress-bar1Indeterminate, & .MuiLinearProgress-bar2Indeterminate, & .MuiLinearProgress-bar1Buffer": {
                    background: `linear-gradient(114deg, ${palette.brand.gradientMagentaBlue})`
                }
            }
        }
    ]
};
//# sourceMappingURL=LinearProgress.js.map